import { Record } from '@gonfalon/immutable-shim/immutableShim';

import { isTeamOrMember } from '#components/SelectTeamOrMember/SelectTeamOrMemberUtils';
import type { Member } from '#utils/members/records/Member';
import type { MemberSummary } from '#utils/members/records/MemberSummary';
import type { Team } from '#utils/teams/records/Team';
import type { TeamSummary } from '#utils/teams/records/TeamSummary';

export interface FlagMaintainerType {
  idOrKey: string;
  kind: 'member' | 'team';
  member?: Member | MemberSummary;
  name: string;
  team?: Team;
}

export function createFlagMaintainer(newMaintainer: Member | MemberSummary | Team | TeamSummary): FlagMaintainer {
  const { isMember, isTeam } = isTeamOrMember(newMaintainer);
  return new FlagMaintainer({
    member: isMember ? (newMaintainer as Member) : undefined,
    team: isTeam ? (newMaintainer as Team) : undefined,
    idOrKey: isMember ? (newMaintainer as Member)._id : (newMaintainer as Team).key,
    kind: isMember ? 'member' : 'team',
  });
}
// FlagMaintainer is a UI-only data model that allows you to have a common interface between team or member maintainers.
export class FlagMaintainer extends Record<FlagMaintainerType>({
  idOrKey: '',
  kind: 'member',
  member: undefined,
  name: '',
  team: undefined,
}) {
  getDisplayName() {
    switch (this.kind) {
      case 'member':
        return this.get('member')?.getDisplayName();
      case 'team':
        return this.get('team')?.getDisplayName();
      default:
        return undefined;
    }
  }
}
